import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';

import { Plans } from '@screens/home/benefits/Plans';
import { Benefits } from '@screens/home/benefits/Benefits';
import { BenefitHero } from '@screens/home/benefits/BenefitHero';
import { PartnersList } from '@screens/home/partners/PartnersList';
import { PartnerBanner } from '@screens/home/partners/PartnerBanner';
import { BenefitsAdditional } from '@screens/home/benefits/BenefitsAdditional';
import { useChangePrice } from '@hooks/useChangePrice';

const useStyles = makeStyles({
  root: {
    paddingBottom: '40px',
    backgroundSize: '20%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    backgroundPositionY: '35%',
  },
});

export const HomeAlt: React.FC = () => {
  const classes = useStyles();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useChangePrice();

  return (
    <div className={classes.root}>
      <PartnersList />
      <Benefits />
      <PartnerBanner />
      <Plans />
      <BenefitHero />
      <BenefitsAdditional />
    </div>
  );
};
